var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 73,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_575_446",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_575_446",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAEmklEQVR4nO3dXagVVRTA8aVZoUFFaRZaEBKVBEGEEGWGmFBQPUURRS+ZGilE9SJJBULid0QRUQ9R0FNURA9W9FKRmpb0oVZQIJUWaNpVs8z7j82d4HDwzlp7Zp8zs87ZPxAuXGetNXvNmb1n5jJHJMuyLMuyLMuyLBFgIrAUmJRyUIEzgeXAFuBI8S/8vCz8LnGuScU+TBRPgLOAtxmzOmHcGcBOxvdl+D8J860u4r4FTBEPgIuAzzsGZRS4PdGRv7Nk8DubUPuTEGouav/fNuBCaTPgYuCnUwzKH8CsmrGXY/dwzVyzipq7/QjMlDYCpgG7SwblC2ByjfhbIxrwWY08k4tax7MLmCptApwNbDcMzMs1coxENGCkRp5XjKe5c6UNipXCRxGDs7BinigVcyyMSPFh6hVeJcAzEUU/W3VJR6SKOSYAT0WkWSVNKo6Yk4ZC/wEeqJFnamwD6pyngUXACUOOsO8LpMHl5m+GIv8F7qwQ/5ziIuiTIkassM3HwJIwR1XIf5fx4NoHTJd+67jQKhPW0Q9Gxp0OrCuucFMJE/ha4ILIWhZ3XQuM503pJ+Bm446viIh5OvBY5Gon1p/AoyFXRF1PGGPPl34ATgO+MhT0XpjUjDEvBT6lf8KV+mURE/M7hpjf9mVVFK4yDcXsBc43xrutx0d92afh1oiLzJ8NMR+qPcCG+zH7lSLCOfNGY7wlFSfYVELuRcZa5xvmg32p78h2F3G/YadeM8Zaapzgem00oglvGOLdV3ugSwoIl+BljgKXGOLc0vCR3y0sN+8w1D3TsDrbkWzAu5LPQ/ekIc7lDZ3zLXOCOjEDT6uR4IZkA9+R+HXD0X+eEuMM5U5j07ZrS9SwuACOKXFe7cUNt4NK0hcMcVbQfo8b9uMlJcaBpEtS4CbDRDbb8DgxfErabkR78gVcZVhAzE3ZgA1Ksq2GGM/hx3rD/uxQYqxJ2YA9SrKVhvPmX/hxVHvgEhYcSoxdKZ92aR+3q5UYj+DPMmWfrlG2H61yF/ZUia5XEv1iiNH5VxJebDHcI/pViXFdigaEK9Yy7xom3zZc8Va5ONMm43DDscziFA14sc5jOeBe/Lq75uPY51M04IOaRYbnwF5tVPbtHmX7zSkaoJ2/r63ZwDYrHUBgjrL9thQN+F5JUnr/BPgBv74z3NeqvL21Ab8rSaYp2x/CrwOG59dl9qdowHElSekDiOJPUrz62/CAqsxxaRrOiXc4J97hnHiHc+Idzol3OCfe4Zx4h3PiHc6Jdzgn3uGceIdz4h3OiXc4J97hnHiHc+Idzol3OCfe4Zx4h3PiHc6Jdzgn3uGceIdz4lnky4/aKtlrN/tqQAbfZxMGbPB9NWFAB99HEwZ88NvdhCEZ/HY2YcgGv11NGNLBb08TGHLSNIacNI0hJ01jyEmWZVmWDSrGXidZ1eGm63cP+KZGA75uun730F8YWGZt0/W7B8yu+Jrj8BUkVzRd/0Cg2kufNjRd98Bg7Ns13o8Y/M0x35KR2ZuwSfl2oxPFnJEHv8dzwvqwwileMzxS/By++OfKniXOsizLsizLsiyTNP4D8XLSxq7nluEAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/Alarm.8f48877f3493d7ebd5e8cac220ddd887.svg";
export { ForwardRef as ReactComponent };